import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../utils/Api";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(""); 
  const [messageType, setMessageType] = useState(""); 

  const validateForm = () => {
    const newErrors = {};
    if (email.trim() === "") newErrors.email = "El campo email es obligatorio.";
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "El email no es válido.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setMessageType("");
    const newErrors = validateForm();
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      await api.post("/reset-password", { email });
      setMessage("Correo de recuperación enviado. Revisa tu bandeja de entrada.");
      setMessageType("success");
      setEmail("");
    } catch (error) {
      console.error("Error al enviar la solicitud:", error);
      setMessage("Hubo un problema al enviar el correo. Inténtalo de nuevo.");
      setMessageType("error");
    }
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "100vh", padding: "1rem", backgroundColor: "#f8f9fa" }}
    >
      {/* Logo encima */}
      <h2 className="fw-semibold mb-4 text-center" style={{ color: "#2C2C2C" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="#FF7A00"
          className="bi bi-clock-history me-2 align-middle"
          viewBox="0 0 16 16"
        >
          <path d="M8.515 1.019A7 7 0 1 0 15 8a.5.5 0 0 0-1 0 6 6 0 1 1-5.485-6.981z" />
          <path d="M7.5 3a.5.5 0 0 1 .5.5v4.25l3.15 1.85a.5.5 0 1 1-.5.866L7.5 8.5V3.5A.5.5 0 0 1 7.5 3z" />
        </svg>
        Turnora
      </h2>

      {/* Tarjeta */}
      <div className="col-12 col-sm-10 col-md-6 col-lg-4 bg-white p-4 rounded shadow text-center">
        <h1 className="mb-2 fs-4">Recordatorio de contraseña</h1>
        <p style={{ fontSize: "14px" }}>
          Te enviaremos un email con instrucciones para recuperar tu contraseña.
        </p>

        <form onSubmit={handleSubmit} className="mt-4">
          <div className="mb-3 text-start">
            <label htmlFor="correo" className="form-label" style={{ fontSize: "14px" }}>
              Correo Electrónico:
            </label>
            <input
              type="email"
              id="correo"
              name="correo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              placeholder="Email"
              required
            />
            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
          </div>

          <button
            type="submit"
            className="btn w-100"
            style={{ background: "#FF7A00", color: "#fff", border: "none" }}
          >
            Recuperar Contraseña
          </button>
        </form>

        {message && (
          <div
            className={`mt-3 ${messageType === "success" ? "text-success" : "text-danger"}`}
          >
            {message}
          </div>
        )}

        <div className="mt-3">
          <Link to="/" style={{ color: "#FF7A00", textDecoration: "none" }}>
            Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
